// InsufficientTimePopUp.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faTimes } from '@fortawesome/free-solid-svg-icons';
import './InsufficientTimePopUp.css';
import { doc, updateDoc } from "firebase/firestore"; 
import { db, auth } from '../../firebase';

export const InsufficientTimePopUp = () => {
  const handleClose = async () => {
    const user = auth.currentUser;
    const userDocRef = doc(db, 'users', user.uid);
    const insufficientTimeRef = doc(userDocRef, 'subscriptionData', 'noTimeAvailable');
    await updateDoc(insufficientTimeRef, { insufficientTime: false });
    window.location.reload();
  };

  const handleUpgrade = async () => {
    const user = auth.currentUser;
    const userDocRef = doc(db, 'users', user.uid);
    const insufficientTimeRef = doc(userDocRef, 'subscriptionData', 'noTimeAvailable');
    await updateDoc(insufficientTimeRef, { insufficientTime: false });
    // Navigation handled by Link
  };

  return (
    <div className="insufpop-overlay" onClick={handleClose}>
      <div className="insufpop-modal" onClick={e => e.stopPropagation()}>
        <div className="insufpop-header">
          <h2>
            <FontAwesomeIcon icon={faHistory} />  
            Out of Minutes
          </h2>
          <button className="insufpop-close" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="insufpop-body">
          <p>
            You’ve exhausted your video processing minutes for this quota period.<br/><br/>
            Upgrade now to unlock more time and keep processing!
          </p>
        </div>

        <div className="insufpop-footer">
          <button className="insufpop-btn-cancel" onClick={handleClose}>
            Maybe Later
          </button>
          <Link to="/settings/plan" onClick={handleUpgrade}>
            <button className="insufpop-btn-upgrade">
              Upgrade Plan
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InsufficientTimePopUp;
